import { render, staticRenderFns } from "./RiskCheckList.vue?vue&type=template&id=025c10e3&scoped=true&"
import script from "./RiskCheckList.vue?vue&type=script&lang=js&"
export * from "./RiskCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025c10e3",
  null
  
)

export default component.exports